import { useFlowersStore } from '../../data/flowers-store';

export enum PlantsTab {
    Default = 0,
    AddNew = 1,
}

const PlantsTabsNavigation = () => {

    const plantsTab = useFlowersStore(store => store.plantsTab);
    const setPlantsTab = useFlowersStore(store => store.setPlantsTab);

    const showNonAlive = useFlowersStore(store => store.showNonAlive);
    const setShowNonAlive = useFlowersStore(store => store.setShowNonAlive);

    const openListTab = () => {
        setPlantsTab(PlantsTab.Default);
    };

    const openAddNewTab = () => {
        setPlantsTab(PlantsTab.AddNew);
    };

    const onNonAliveCheckboxChange = () => {
        setShowNonAlive(!showNonAlive);
    };

    return (
        <nav className="flex border-b-8 mb-8 border-slate-400 rounded-r-md">
            <button
                onClick={ openListTab }
                className={ `border-t border-l border-r px-10 py-2 mr-2 rounded-t-md border-slate-400 ${ plantsTab === PlantsTab.Default ? 'bg-slate-400 text-white' : '' }` }
                type="button">
                List
            </button>

            <button
                onClick={ openAddNewTab }
                className={ `border-t border-l border-r px-6 py-2 rounded-t-md border-slate-400 ${ plantsTab === PlantsTab.AddNew ? 'bg-slate-400 text-white' : '' }` }
                type="button">
                Add New
            </button>

            <label className="flex items-center ml-2 md:ml-auto text-xs md:text-sm">
                <input
                    className="mr-2"
                    checked={ showNonAlive }
                    type="checkbox"
                    onClick={ onNonAliveCheckboxChange }
                />

                Show Non-Alive
            </label>
        </nav>
    )
};

export default PlantsTabsNavigation;